// extracted by mini-css-extract-plugin
export var author = "post-item-module--author--6ee21";
export var categories = "post-item-module--categories--d16fe";
export var date = "post-item-module--date--5914d";
export var image = "post-item-module--image--d63e0";
export var link = "post-item-module--link--6a4fc";
export var meta = "post-item-module--meta--10986";
export var newsDate = "post-item-module--newsDate--557e4";
export var root = "post-item-module--root--c1cf4";
export var text = "post-item-module--text--43a02";
export var title = "post-item-module--title--f5583";